<template lang="pug">
  //- transition(
  //-   name="simple-list"
  //- )
  .simple-select-form__list(
    @click="onClickList($event)"
  )
    ul
      li(
        v-for="li in listData"
        :class="{ 'li-selected': li.value !== undefined ? li.value === defaultValue.value : li === defaultValue }"
        @click="onSelectItem(li)"
      ) {{li.text ? li.text : li}}
</template>

<script>
export default {
  name: "SimpleSelectList",
  components: {},
  props: {
    showList: {
      type: Boolean,
      default: false
    },
    listData: {
      type: Array,
      default: () => []
    },
    defaultValue: {
      type: [String, Object],
      default: ""
    }
  },
  data() {
    return {
      selected: true
    };
  },
  methods: {
    onSelectItem(li) {
      this.$emit("onSelectItem", li);
      this.$emit("close");
    },
    onClickList(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    onBodyClick() {
      this.$emit("close");
    }
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.onBodyClick);
  },
  created() {
    document.body.addEventListener("click", this.onBodyClick);
  }
};
</script>
